import React from 'react';

import Icon from '@components/icon/Icon.tsx';
import getEndText from '@functions/getEndText.ts';
import getFormatedDate from '@functions/getFormatedDate.ts';

import I from '../types.ts';

const renderFoot: I['renderFoot'] = function () {
    const { article } = this.props;

    return (
        <div className="publicBlogPreview__foot _row">
            <div className="publicBlogPreview__footTime _row">
                <i className="publicBlogPreview__footTimeIcon">
                    <Icon name="blog-time" />
                </i>
                {article.time} {getEndText(article.time, ['минута', 'минуты', 'минут'])}
            </div>
            <div className="publicBlogPreview__footDate">
                {getFormatedDate({
                    date: new Date(article?.createdDate),
                    type: 'yearText',
                })}
            </div>
        </div>
    );
};

export default renderFoot;
